import Vue from 'vue';
import VueQrcodeReader from 'vue-qrcode-reader';

Vue.use(VueQrcodeReader);
